module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gijsbert Van den Brink, C. Van der Kooi\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Cornelis van der Kooi")]), _vm._v(" is professor of systematic theology and director of the Center for Evangelical and Reformation Theology at the Free University of Amsterdam."), _c('BR'), _c('BR'), _c('B', [_vm._v("Gijsbert van den Brink")]), _vm._v(" is university research chair in theology and science at the Theological Faculty of the Free University of Amsterdam.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/HaezTS/images/cover.jpg?1684975174687",
      "alt": "This image is the cover for the book Christian Dogmatics"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Christian Dogmatics\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("A fresh, inviting text on the content of Christian faith in our contemporary context")]), _c('br'), _c('br'), _vm._v(" This one-volume systematic theology presents an accessible, orthodox overview of the Christian faith for students, teachers, pastors, and serious lay readers. Cornelis van der Kooi and Gijsbert van den Brink not only cover all the traditional themes-creation, sin, Jesus Christ, Scripture, and so on-but also relate those classical themes to contemporary developments like Pentecostalism, postfoundationalism, and evolutionary theory."), _c('br'), _c('br'), _vm._v(" Consisting of sixteen chapters, the book is ideal for classroom use. Each chapter begins with engaging questions and a statement of learning goals and concludes with a list of recommended further reading. Written in a student-friendly tone and style and expertly translated and edited, van der Kooi and van den Brink's "), _c('i', [_vm._v("Christian Dogmatics")]), _vm._v(" splendidly displays the real, practical relevance of theology to the complexities of our world today.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0